import Tippy from '@tippyjs/react';
import { Colaboracao, FocoNoCliente, Inovacao, MandouBem, Resolutividade, Lideranca, Uau, Valeu } from 'components/icons';
import InputMask from 'react-input-mask';

import { format, differenceInDays } from 'date-fns';

import { UserAvatar } from 'components/user-avatar';
import { useAuth } from 'context/AuthContext';
import { FormEvent, useEffect, useRef, useState } from 'react';
import { BiInfoCircle } from 'react-icons/bi';
import { FaHeart } from 'react-icons/fa';
import { MdModeComment } from 'react-icons/md';
import { registerInteraction } from 'services/interactions.service';
import { useModal } from 'context/ModalContext';
import { getKPISentHistory, getKPISentHistoryPag, getServerTime } from 'services/dashboard.service';
import Box from 'components/ui/box';
import ArticlePlaceholder from 'components/ui/article-placeholder';
import { FiEdit3 } from 'react-icons/fi';
import { getActionById, updateAction } from 'services/actionlog.service';
import Button from 'components/ui/button';
import { TbSearch } from 'react-icons/tb';
import { convertEmojis } from 'utils/helpers';
import Humanograma from 'components/Humanograma';
import { BsArrowReturnLeft } from 'react-icons/bs';
import { TbMessageCancel } from 'react-icons/tb';
import ModalCancelRecognition from 'components/modal-cancel-recognition';

const iconSize = 30;
const Coins: any = {
  uau: (
    <div className="w-[30px]">
      <Uau size={iconSize} />
    </div>
  ),
  mandou: (
    <div className="w-[30px]">
      <MandouBem size={iconSize} />
    </div>
  ),
  valeu: (
    <div className="w-[30px]">
      <Valeu size={iconSize} />
    </div>
  ),
};

const CoinLabel: any = {
  uau: 'Arrasou',
  mandou: 'Top',
  valeu: 'Curti',
};

const Behaviors: any = {
  colaboracao: (
    <div className="w-[30px]">
      <Colaboracao size={iconSize} />
    </div>
  ),
  inovacao: (
    <div className="w-[30px]">
      <Inovacao size={iconSize} />
    </div>
  ),
  foco: (
    <div className="w-[30px]">
      <FocoNoCliente size={iconSize} />
    </div>
  ),
  resolutividade: (
    <div className="w-[30px]">
      <Resolutividade size={iconSize} />
    </div>
  ),
  lideranca: (
    <div className="w-[30px]">
      <Lideranca size={iconSize} />
    </div>
  ),
};

const BehaviorLabel: any = {
  colaboracao: 'Colaboração',
  inovacao: 'Inovação',
  foco: 'Foco no Cliente',
  resolutividade: 'Proatividade',
  lideranca: 'Liderança Engajadora',
};

interface Props {
  activeModal: (data: { message: string; id: string }) => void;
  filter?: any;
  message?: { message: string; id: string } | null;
}

export default function Recognition(data: Props) {
  const { activeModal, message, filter } = data;
  const { user, currentCycle } = useAuth();
  const [list, setList] = useState<any[]>([]);
  const [time, setTime] = useState<number>();
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const [load, setLoad] = useState(false);
  const [currentFilter, setCurrentFilter] = useState({});
  const [cancelRecognitionId, setCancelRecognitionId] = useState<string | undefined>();

  const { showModal } = useModal();
  const searchRef = useRef<any>();

  const [loadingList, setLoadingList] = useState(true);

  function hasLike(item: any) {
    if (item?.attributes?.status !== 'OK') {
      return false;
    }

    return !!item?.interaction.find((i: any) => i.player === user?._id && !!i.like);
  }

  function canEdit(item: any) {
    if (item?.attributes?.status !== 'OK') {
      return false;
    }

    if (!!item && !!time) {
      const differenceTime = differenceInDays(new Date(time), new Date(item.time));

      return differenceTime <= 10;
    }

    return false;
  }

  function getComment(item: any) {
    if (item?.attributes?.status !== 'OK') {
      return null;
    }

    const interaction = item.interaction?.find((e: any) => !!e.message?.trim().length);

    if (interaction) {
      return interaction;
    } else {
      return null;
    }
  }

  function getReturnComment(item: any) {
    if (
      (item?.attributes?.status !== 'devolvido' && item?.attributes?.status !== 'cancelado') ||
      !item?.returnRecognition?.message
    ) {
      return null;
    }

    return item?.returnRecognition?.message;
  }

  function removeFromList(id: string) {
    setList(list.filter(x => x._id !== id));
  }

  async function updateRecognition(data: { message: string; id: string }) {
    const resp = await getActionById(data.id);
    resp.attributes.message = data.message;

    await updateAction(resp);

    const newList = [...list];

    const index = newList.findIndex(e => e._id === data.id);

    newList[index].attributes.message = data.message;

    setList(newList);
  }

  useEffect(() => {
    setCurrentFilter(filter);
  }, [filter]);

  useEffect(() => {
    async function loadData() {
      setLoadingList(true);
      const rangeItem = page ? page * 5 : 0;

      if (page) setLoad(true);

      const data = await getKPISentHistoryPag(
        user?._id,
        currentFilter,
        rangeItem,
        5,
        currentCycle?.date_start,
        currentCycle?.date_finish,
      );
      setList(page ? [...list, ...data.result] : data.result);

      setTotal(data.range.total);
      setTotalPage(data.range.pages);

      setLoadingList(false);
      setLoad(false);
    }

    if (!!user && !!currentCycle) {
      loadData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentCycle, user, page, currentFilter]);

  useEffect(() => {
    async function loadTime() {
      const res = await getServerTime();
      setTime(res);
    }

    if (!!user && !!currentCycle) {
      loadTime();
    }
  }, [currentCycle, user]);

  useEffect(() => {
    if (!!message?.message && !!message?.id) {
      updateRecognition(message);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message]);

  const onSearch = (e: FormEvent) => {
    // console.log(searchRef.current.value);
    setCurrentFilter({
      ...currentFilter,
      ...{ search: searchRef.current.value },
    });

    e.preventDefault();
  };

  return (
    <>
      <div className="my-14">
        <div className="flex flex-col items-start justify-start lg:flex-row lg:justify-between lg:items-center mb-8">
          <h3 className="text-white font-bold text-xl mb-4 lg:mb-0">
            Reconhecimentos enviados
            <span className="text-xl lg:text-2xl font-bold text-yellow ">{total ? ` (${total})` : null}</span>
          </h3>
          <div className="flex flex-row items-center space-x-4">
            <form onSubmit={onSearch} className="pl-1 -ml-1 flex-1 flex space-x-5">
              <InputMask
                placeholder="Pesquise com nome ou e-mail"
                alwaysShowMask={false}
                mask={''}
                ref={(ref: any) => {
                  searchRef.current = ref;
                }}
                inputMode="search"
                style={{ fontSize: 16 }}
                className="min-w-full lg:min-w-[416px] bg-maastricht-blue text-sm text-white font-thin flex-1 rounded-md py-2 px-4"
              />
              <button type="submit">
                <TbSearch size={28} className="cursor-pointer hover:ring-2 mr-1 rounded-full" />
              </button>
            </form>
          </div>
        </div>

        <Box className="relative bg-oxford-blue border-electric-blue lg:p-6 flex flex-col justify-center items-center border-opacity-100 bg-opacity-100">
          {loadingList && (
            <div className="space-y-2 w-full">
              <ArticlePlaceholder />
              <ArticlePlaceholder />
            </div>
          )}

          {!loadingList && (
            <div className="space-y-2 w-full">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                {!!list?.length &&
                  list?.map((item: any) => (
                    <div
                      className={`bg-maastricht-blue-3 rounded-xl text-gray-300 space-y-2 py-6 px-6 lg:px-8 ${
                        item?.attributes?.status !== 'OK' ? 'bg-opacity-50' : ''
                      }`}
                      key={item?._id}
                    >
                      <div className="flex flex-col lg:flex-col items-start lg:items-start mb-5">
                        <div className="flex-1 flex flex-col-reverse lg:flex-row items-start space-x-2 leading-tight w-full">
                          <div className="flex flex-1 w-full items-start">
                            <div className="mr-2">
                              <UserAvatar data={item.target} />
                            </div>
                            <div className="flex-1 w-full block">
                              <Humanograma
                                data={{
                                  ...item,
                                  nome: item?.target?.name,
                                  funcao: item?.target?.funcao,
                                  _id: item?.attributes?.target,
                                }}
                              >
                                <div className="w-full block text-sm lg:text-base text-alice-blue font-thin">
                                  VOCÊ enviou para: <br />
                                  <span className="font-semibold">
                                    {item.target.nome_guerra || item.target.name.split(' ')[0]}
                                  </span>{' '}
                                  ({item.attributes.target})
                                  <BiInfoCircle className="inline relative -top-[2px] ml-1" />
                                </div>
                              </Humanograma>

                              <div className="block 2xl:flex flex-col 2xl:flex-row 2xl:items-center w-full space-y-2 2xl:space-y-0 2xl:space-x-2 mt-1">
                                <div className="inline-flex flex-row items-center space-x-2 px-3 py-1 text-yellow bg-oxford-blue rounded-full">
                                  {Coins[item.attributes.coin]} <span className="text-xs">{CoinLabel[item.attributes.coin]}</span>
                                </div>
                                <br className="block 2xl:hidden" />
                                <div className="inline-flex flex-row items-center space-x-2 px-3 py-1 text-yellow bg-oxford-blue rounded-full">
                                  {Behaviors[item.attributes.behavior]}{' '}
                                  <span className="text-xs">{BehaviorLabel[item.attributes.behavior]}</span>
                                </div>

                                {!!item.total && item?.attributes?.status === 'OK' ? (
                                  <>
                                    <br className="block 2xl:hidden" />
                                    <div className="inline-flex items-center space-x-2">
                                      <div
                                        className={`ring-white whitespace-nowrap 2xl:mt-0 flex-1 2xl:flex-none inline-flex flex-row items-center space-x-2 px-2 bg-oxford-blue py-1 text-electric-blue rounded-full`}
                                      >
                                        <span>total = {item.total} pontos</span>{' '}
                                      </div>
                                    </div>
                                  </>
                                ) : null}

                                {item?.attributes?.status === 'devolvido' ? (
                                  <>
                                    <br className="block 2xl:hidden" />
                                    <div className="inline-flex flex-row items-center space-x-2 px-3 py-1 text-[#ED2B48] bg-oxford-blue rounded-full">
                                      <BsArrowReturnLeft size={16} />
                                      <span className="text-xs">Reconhecimento devolvido</span>
                                    </div>
                                  </>
                                ) : null}

                                {item?.attributes?.status === 'cancelado' ? (
                                  <>
                                    <br className="block 2xl:hidden" />
                                    <div className="inline-flex flex-row items-center space-x-2 px-3 py-1 text-[#ED2B48] bg-oxford-blue rounded-full">
                                      <TbMessageCancel size={16} />
                                      <span className="text-xs">Reconhecimento cancelado</span>
                                    </div>
                                  </>
                                ) : null}
                              </div>
                            </div>
                          </div>

                          <div className="text-gray-400 text-xs leading-none flex justify-end w-full lg:w-auto my-3 lg:my-0">
                            <span>{format(new Date(item.time), 'dd MMM yyyy | HH:mm')}</span>
                          </div>
                        </div>
                      </div>

                      <hr className="border-prussian-blue" />

                      {!!item.attributes.message && (
                        <>
                          <div className="p-2 flex-1 flex-col">
                            <div className="flex justify-between mb-3">
                              <p className="text-electric-blue font-thin">Reconhecimento enviado:</p>
                              {canEdit(item) && (
                                <button
                                  onClick={() => {
                                    activeModal({
                                      id: item._id,
                                      message: item.attributes.message,
                                    });
                                  }}
                                  className={`flex items-center cursor-pointer text-electric-blue`}
                                >
                                  <FiEdit3 size={20} className="mr-2" /> Editar
                                </button>
                              )}
                            </div>
                            <div
                              className="text-alice-blue break-words"
                              dangerouslySetInnerHTML={{
                                __html: convertEmojis(item.attributes.message),
                              }}
                            />
                          </div>

                          {!!getComment(item) && (
                            <div className="p-2 flex-1 flex-col">
                              <p className="text-electric-blue font-thin">Comentário:</p>
                              <div
                                className="text-alice-blue"
                                dangerouslySetInnerHTML={{
                                  __html: convertEmojis(getComment(item).message),
                                }}
                              ></div>
                            </div>
                          )}

                          {!!getReturnComment(item) && (
                            <div className="p-2 flex-1 flex-col">
                              <p className="text-electric-blue font-thin">
                                Motivo {item?.attributes?.status === 'cancelado' ? 'do cancelamento' : 'da devolução'}:
                              </p>
                              <div
                                className="text-alice-blue"
                                dangerouslySetInnerHTML={{
                                  __html: convertEmojis(getReturnComment(item)),
                                }}
                              ></div>
                            </div>
                          )}
                        </>
                      )}

                      {(!!hasLike(item) || !!item.canCancelRecognition) && (
                        <div className="flex justify-end space-x-6">
                          {!!item.canCancelRecognition && (
                            <button
                              className={`flex items-center uppercase text-[#ED2B48]`}
                              onClick={() => setCancelRecognitionId(item._id)}
                            >
                              <TbMessageCancel size={20} className="mr-2" />
                              Cancelar
                            </button>
                          )}

                          {!!hasLike(item) && (
                            <button className={`flex items-center uppercase cursor-default text-electric-blue`}>
                              <FaHeart size={20} className="mr-2" />
                              Curtido
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                  ))}

                {!list?.length && (
                  <>
                    <p className="text-white text-base text-center font-light leading-none block py-6">
                      Nenhum reconhecimento enviado até o momento.
                    </p>
                  </>
                )}
              </div>

              {page + 1 < totalPage && (
                <div className="w-full flex justify-center">
                  <Button disabled={load} className="px-4 py-2 mx-auto" type="button" onClick={() => setPage(page + 1)}>
                    {load ? 'Carregando...' : 'Carregar mais'}
                  </Button>
                </div>
              )}
            </div>
          )}
        </Box>
      </div>

      {!!cancelRecognitionId && (
        <ModalCancelRecognition
          callback={function (action: string): void {
            if (action === 'remove') {
              setPage(0);
              setCurrentFilter({});
            } else if (action === 'cantCancel') {
              setList(prevstate =>
                prevstate.map(x => {
                  const obj = { ...x };

                  if (obj._id === cancelRecognitionId) {
                    obj.canCancelRecognition = false;
                  }

                  return obj;
                }),
              );
            } else if (action === 'close') {
              setCancelRecognitionId(undefined);
            }
          }}
          id={cancelRecognitionId}
          type="cancel"
        />
      )}
    </>
  );
}
